import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import heroBackground from "@/assets/hero-background.jpg";
import { NewsletterSignup } from "./NewsletterSignup";
import { useAnimatedCounter } from "@/hooks/useAnimatedCounter";
const Hero = () => {
  const navigate = useNavigate();
  const membersCounter = useAnimatedCounter({
    end: 500,
    duration: 2000,
    suffix: '+',
    startOnView: false
  });
  const ratingCounter = useAnimatedCounter({
    end: 4.9,
    duration: 2000,
    decimals: 1,
    startOnView: false
  });
  const reviewsCounter = useAnimatedCounter({
    end: 200,
    duration: 2000,
    suffix: '+',
    startOnView: false
  });
  return <>
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background with gradient overlay */}
        <div className="absolute inset-0 z-0">
          <img src={heroBackground} alt="Digital marketing growth and analytics dashboard" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-br from-background via-background/90 to-background/70" />
        </div>

        {/* Content */}
        <div className="container mx-auto px-4 py-20 relative z-10">
          <div className="max-w-4xl mx-auto text-center space-y-8 animate-in fade-in duration-1000">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
              <Sparkles className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-primary">Transform Your Business in 90 Days</span>
            </div>

            {/* Main Headline */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-tight">
              LaunchTo<span className="bg-gradient-to-r from-blue-600 via-purple-600 to-purple-700 bg-clip-text text-transparent animate-gradient">Revenue</span>
            </h1>
            <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground mt-2">
              More Than a Course.
            </p>
            <p className="text-lg sm:text-xl md:text-2xl text-muted-foreground/70 mt-1">
              Your Complete Business Ecosystem.
            </p>

            {/* Subheadline */}
            <p className="text-lg sm:text-xl md:text-xl lg:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Build, automate, and monetize your brand with AI tools, a private community, and a dashboard designed to grow your business.
            </p>

          {/* Newsletter Signup */}
          <NewsletterSignup />

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <Button size="lg" className="text-base px-8 py-6 h-auto rounded-full shadow-lg shadow-primary/30 hover:shadow-xl hover:shadow-primary/40 transition-all" onClick={() => window.open("https://launchtorevenue.com/auth", "_blank")}>
              Join the Ecosystem <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button size="lg" variant="outline" className="text-base px-8 py-6 h-auto rounded-full" onClick={() => document.getElementById('features')?.scrollIntoView({
              behavior: 'smooth'
            })}>
              Learn More
            </Button>
            
          </div>

          {/* Social Proof */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 pt-8 text-sm">
            <div className="flex items-center gap-2">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gradient-to-br from-primary to-accent border-2 border-background" />)}
              </div>
              <span className="text-muted-foreground">
                <span className="font-semibold text-foreground">{membersCounter.formattedValue}</span> Active Members
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl">⭐</span>
              <span className="font-semibold">{ratingCounter.formattedValue}</span>
              <span className="text-muted-foreground">
                from <span className="font-semibold text-foreground">{reviewsCounter.formattedValue}</span> reviews
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Animated gradient orbs */}
      <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-primary/30 rounded-full blur-[128px] animate-pulse" />
      <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-accent/30 rounded-full blur-[128px] animate-pulse delay-1000" />
    </section>
    </>;
};
export default Hero;